import { onDisconnect, push } from "firebase/database";
import {
    getFirebaseClienteInstanceName,
    getUsuarioConexaoCRMV2Ref,
} from "../../../Services/Config/ConfigFirebaseCliente";

export function GoOnlineCRMV2Controller(
    ID_ORGANIZACAO: string,
    ID_USUARIO: number
) {
    const usuarioOnlineRef = getUsuarioConexaoCRMV2Ref(
        ID_ORGANIZACAO,
        ID_USUARIO
    );
    const conexaoRef = push(usuarioOnlineRef, getFirebaseClienteInstanceName());
    onDisconnect(conexaoRef).remove();
}
